export default __webpack_public_path__ + "static/media/BankTransfersNonVirtualAccountPmtPrev.c4176c9a.jpeg";